
export const columnsData = [{
    name: "MPI  <br/> 市场渗透率指数",
    key: "mpi",
    type: "number"
}, {
    name: "Ranking  <br/> 排名",
    key: "mpi_ranking",
    type: "number"
}, {
    name: "ARI  <br/> 平均房价指数",
    key: "ari",
    type: "number"
}, {
    name: "Ranking  <br/> 排名",
    key: "ari_ranking",
    type: "number"
}, {
    name: "RGI  <br/> 收益率指数",
    key: "rgi",
    type: "number"
}, {
    name: "Ranking  <br/> 排名",
    key: "rgi_ranking",
    type: "number"
}, {
    name: "Rooms <br/> 客房数",
    key: "rooms",
    type: "number"
}, {
    name: "Rms Avaliable <br/> 可售客房数",
    key: "rooms_avaliable",
    type: "number"
}, {
    name: "Rms Sold <br/>售出房数",
    key: "rooms_sold",
    type: "number"
}, {
    name: "OCC<br/> 客房率",
    key: "occ",
    type: "string"
}, {
    name: "Revn <br/>客房收入",
    key: "revn",
    type: "number"
}, {
    name: "Avg Rate  <br/> 平均房价",
    key: "avg_rate",
    type: "number"
}, {
    name: "RevPAR  <br/> 可售房平均收入",
    key: "revpar",
    type: "number"
},]; 


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/roomsKPIAnalysisSummary/data.js